import ITable from '~/interfaces/ITable';
import { bff } from '~/services/bff';

type registerOrderInTableProps = {
  parseData: any;
  table: ITable;
  waiter_name: string;
};

const { REACT_APP_FIREBASE_PROJECT } = process.env;

export async function registerOrderInTable({
  parseData,
  table,
  waiter_name,
}: registerOrderInTableProps): Promise<void> {
  await bff.post(`/tables-orders/${REACT_APP_FIREBASE_PROJECT}`, {
    order: JSON.stringify(parseData),
    waiter_name,
  });

  // const q = query(
  //   collection(DB, 'table_orders'),
  //   where('table_id', '==', table.uid),
  //   where('status', '==', 1),
  //   // limit(1),
  // );

  // const findTable = await getDocs(q);

  // if (findTable && findTable.docs.length > 0) {
  //   const currentTable = findTable.docs[0].data() as ITableOrders;

  //   const ordersList = [...currentTable.orders, parseData];

  //   await updateDoc(doc(DB, 'table_orders', currentTable.uid), {
  //     orders: ordersList,
  //     total: currentTable.total + parseData.total,
  //     total_formmated: getCurrencyFormatted(
  //       currentTable.total + parseData.total,
  //     ),
  //   });
  // } else {
  //   const tableOrder = {
  //     uid: v4(),
  //     table_id: table.uid,
  //     table_name: table.name,
  //     user_id: table.user_id,
  //     company_id: table.company_id,
  //     orders: [parseData],
  //     status: 1,
  //     opened: new Date(),
  //     total: parseData.total,
  //     total_formmated: getCurrencyFormatted(parseData.total),
  //   } as ITableOrders;

  //   await setDoc(doc(DB, 'table_orders', tableOrder.uid), tableOrder);
  // }
}
